import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'postingMedia',
  urlRoot: '/posting_media'
})
